import React from 'react';
import { Card, Avatar, CardContent, Typography, Box } from '@mui/material';

interface Props {
  title: string;
  body: string;
  icon: string;
  url?: string;
}
const CustomNotification = React.forwardRef<HTMLDivElement, Props>(({ title, body, icon, url }, ref) => {
    const handleClick = () => {
        if (url) {
          window.location.href = url;
        }
      };

  return (
    <Box ref={ref}>
      <Card
        onClick={handleClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          maxWidth: 360,
          p: 1,
          boxShadow: 3,
        }}
      >
        <Avatar src={icon} sx={{ width: 48, height: 48, mr: 2 }} />
        <CardContent sx={{ p: 0 }}>
          <Typography variant="subtitle1" fontWeight="bold">
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {body}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
});

// debug için bileşene isim verelim
CustomNotification.displayName = 'CustomNotification';

export default CustomNotification;